import * as actionTypes from "../actionTypes";

export function showAppTitle(show) {
  return { type: actionTypes.SET_SHOW_APPTITLE, data: show };
}

export function showMaintasks(show) {
  return { type: actionTypes.SET_SHOW_MAINTASKS, data: show };
}

export function showSidebar(show) {
  return { type: actionTypes.SET_SHOW_SIDEBAR, data: show };
}

export function disableLaunchpad(disable) {
  return { type: actionTypes.SET_DISABLE_LAUNCHPAD, data: disable };
}

export function setBosServerUnavailable(unavailable) {
  return { type: actionTypes.SET_BOSSERVER_UNAVAILABLE, data: unavailable };
}

export function setApplicationIdle(idle) {
  return { type: actionTypes.SET_APPLICATION_IDLE, data: idle };
}

export function setUILanguage(langIsoCode) {
  return { type: actionTypes.SET_UILANGUAGE, data: langIsoCode };
}

export function setDataViewLanguage(langIsoCode) {
  return { type: actionTypes.SET_DATAVIEWLANGUAGE, data: langIsoCode };
}